import React from 'react';
import "../styles/About.css";

function About() {
  return (
    <section className='about-section'>
        <h2 className='about-title'>About AriaRo 3.0</h2>
        <p className='about-text'>AriaRo 3.0 is the annual flagship tech symposium of the UnitedWorld Institute Of Technology (UIT) at Karnavati University. This multi-day event is designed to bring together tech enthusiasts, coders, innovators, and industry professionals for a series of competitive events, workshops, and exhibitions. With a focus on cutting-edge technologies like cybersecurity, IoT, and robotics, AriaRo 3.0 offers a platform for students to showcase their skills, learn from experts, and engage in collaborative innovation.</p>
    </section>
  )
}

export default About